define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var HilitorClassRegistry = /** @class */ (function () {
        function HilitorClassRegistry() {
            this.classSuffixAssignment = {};
            this.classSuffixes = [
                'blue-light-euf',
                'gray',
                'yellow',
                'orange',
                'red',
                'brown',
                'violet',
                'blue',
                'blue-dark-euf',
                'turquoise',
                'green',
                'green-light',
            ];
            this.classSuffixIndex = 0;
        }
        HilitorClassRegistry.getInstance = function () {
            if (!HilitorClassRegistry.instance) {
                HilitorClassRegistry.instance = new HilitorClassRegistry();
            }
            return HilitorClassRegistry.instance;
        };
        HilitorClassRegistry.reset = function () {
            HilitorClassRegistry.getInstance().clear();
        };
        HilitorClassRegistry.prototype.getClassForRegex = function (reg) {
            var objectKey = reg.toLowerCase();
            if (this.classSuffixAssignment[objectKey]) {
                return this.classSuffixAssignment[objectKey];
            }
            var classIndex = this.classSuffixIndex++ % this.classSuffixes.length;
            this.classSuffixAssignment[objectKey] = 'tx-domfilter-' + this.classSuffixes[classIndex];
            return this.classSuffixAssignment[objectKey];
        };
        HilitorClassRegistry.prototype.clear = function () {
            this.classSuffixAssignment = {};
            this.classSuffixIndex = 0;
        };
        return HilitorClassRegistry;
    }());
    exports.default = HilitorClassRegistry;
});
